module.exports = __webpack_public_path__ + "img/cover-img.07c5ef13.png";